import { getClient } from "./client";
import type { ApiEvent, ApiGameSponsor, ApiMatchup, ApiTeam } from "./shared";

export type ApiScheduledGame = {
  id: string;

  tokensGiven: number;
  gameSponsor: null | ApiGameSponsor;
  team: ApiTeam;

  timestamp: string;
  status: "upcoming" | "about_to_start" | "in_progress" | "finished";
} & (
  | { typeEvent: null; typeMatchup: ApiMatchup }
  | { typeEvent: ApiEvent; typeMatchup: null }
);

export const getSchedule = () =>
  getClient().get("/api/schedule").json<ApiScheduledGame[]>();
